<div class="slider__item" [style]="width ? '--slider-item-width: ' + width + 'px' : ''">
  <ng-content></ng-content>
</div>
